jQuery(document).ready(function($){
  
  $('.z_benefitsSlider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.z_product-list.slider-enabled').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.z_review-section .reviews').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() > 50) {
      $('sticky-header').addClass('active');
    } else {
      $('sticky-header').removeClass('active');
    }
  });
  
});


jQuery(document).on("click", "sticky-header.header-wrapper header.header .z_col.z_colRight .z_headerIcon ul li a#z_searchIcon", function(){
    jQuery(".header__icon.header__icon--search").click();
});

jQuery(document).on("click", "sticky-header.header-wrapper header.header .z_col.z_colRight .z_headerIcon ul li a#z_accountIcon", function() {
    var accountUrl = jQuery("a.header__icon.header__icon--account.link").attr("href");
    if (accountUrl) {
        window.location.href = accountUrl;
    }
});